var _path, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircularPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 29.0956C25.663 29.0956 31.875 23.4253 31.875 16.4306C31.875 9.43593 25.663 3.76562 18 3.76562C10.337 3.76562 4.125 9.43593 4.125 16.4306C4.125 23.4253 10.337 29.0956 18 29.0956Z",
    stroke: "#CCF900",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 20,
    height: 20,
    fill: "url(#pattern0_9946_3587)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_9946_3587",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_9946_3587",
    transform: "scale(0.00666667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_9946_3587",
    width: 150,
    height: 150,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWBAMAAADOL2zRAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAASUExURQAAAMr6AMv3AMr3AMz5AMz6ALQSecoAAAAGdFJOUwAwgGD/m57wdbIAAAAJcEhZcwAAFxEAABcRAcom8z8AAAB0SURBVGje7dqxCYAwEEDRiAsIbiAOoIgLSDZw/12sElBIIQmC8H59vPKuuSDpP3VTaqi2+phaWCwWi8VisVgsFovFYr2yxq3Unq2zOLPerDnWdLBYLBbrYbXc0eXcRxaLxWKxWCwWi8VisdpbLX+jJH1UCBf5IFUd5/eRzQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularPlus);
export default __webpack_public_path__ + "static/media/circular-plus.81f4920bc2e34a4af72d70bc7e9af20d.svg";
export { ForwardRef as ReactComponent };